/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Sports_And_Fitness16Inputs */

const en_cv_extract_form_enum_sports_and_fitness16 = /** @type {(inputs: Cv_Extract_Form_Enum_Sports_And_Fitness16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sports and Fitness`)
};

const de_cv_extract_form_enum_sports_and_fitness16 = /** @type {(inputs: Cv_Extract_Form_Enum_Sports_And_Fitness16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sport und Fitness`)
};

/**
* | output |
* | --- |
* | "Sports and Fitness" |
*
* @param {Cv_Extract_Form_Enum_Sports_And_Fitness16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_sports_and_fitness16 = /** @type {((inputs?: Cv_Extract_Form_Enum_Sports_And_Fitness16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Sports_And_Fitness16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_sports_and_fitness16(inputs)
	return en_cv_extract_form_enum_sports_and_fitness16(inputs)
});
export { cv_extract_form_enum_sports_and_fitness16 as "cv_extract_form_enum_SPORTS_AND_FITNESS" }